import {PricingPrice} from "./PricingPrice";
import {PricingCurrentDTO} from "./dto/PricingDTO";
import {PricingNote} from "./PricingNote";

export class PricingCurrent
{
    private readonly _price: PricingPrice
    private readonly _note?: PricingNote
    private readonly _multidealNote?: PricingNote

    constructor(current: PricingCurrentDTO) {
        if(current) {
            this._price = new PricingPrice( current.price );
            this._note = current.note ? new PricingNote(current.note) : null;
            this._multidealNote = current.multideal_note ? new PricingNote(current.multideal_note) : null;
        }
    }

    get price(): PricingPrice {
        return this._price;
    }

    get note(): PricingNote | null {
        return this._note;
    }

    hasNote(): boolean {
        return this._note != null;
    }

    get multidealNote(): PricingNote | null {
        return this._multidealNote;
    }

    hasMultidealNote(): boolean {
        return this._multidealNote != null;
    }
}
